import SuggestionCard, { SuggestionCardProps } from './SuggestionCard';
import SuggestionList, { SuggestionListProps } from './SuggestionList';

export default SuggestionCard;
export { SuggestionList };
export type { SuggestionCardProps, SuggestionListProps };
